import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState } from 'react';
import featureFlags from '@/config/features';
import Dropdown, { Button as DropdownButton, Item as DropdownItem, Action as DropdownAction } from '@/components/lists/Dropdown';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FileUploadIcon = function FileUploadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5558_661)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9154 0.286791C11.4142 0.166451 10.8944 0.166698 10.2065 0.167026L6.57197 0.16706C5.69992 0.167046 4.98019 0.167035 4.3939 0.214937C3.78496 0.264689 3.2252 0.371467 2.69942 0.639366C1.88405 1.05482 1.22113 1.71773 0.80568 2.5331C0.537782 3.05888 0.431004 3.61864 0.381252 4.22758C0.33335 4.81387 0.333361 5.53359 0.333374 6.40564V15.5951C0.333361 16.4672 0.33335 17.1869 0.381252 17.7732C0.431004 18.3821 0.537782 18.9419 0.80568 19.4677C1.22113 20.2831 1.88405 20.946 2.69942 21.3614C3.2252 21.6293 3.78496 21.7361 4.3939 21.7859C4.98019 21.8338 5.6999 21.8337 6.57194 21.8337H11.4281C12.3002 21.8337 13.0199 21.8338 13.6062 21.7859C14.2151 21.7361 14.7749 21.6293 15.3007 21.3614C16.116 20.946 16.779 20.2831 17.1944 19.4677C17.4623 18.9419 17.5691 18.3821 17.6188 17.7732C17.6667 17.1869 17.6667 16.4672 17.6667 15.5951L17.6667 7.62726C17.6671 6.93936 17.6673 6.41957 17.547 5.91832C17.4408 5.47617 17.2657 5.05347 17.0281 4.66576C16.7588 4.22623 16.3911 3.85887 15.9044 3.37268L14.4611 1.92934C13.9749 1.44268 13.6075 1.07497 13.168 0.80562C12.7803 0.568029 12.3576 0.392943 11.9154 0.286791ZM10.0834 2.33373H6.61671C5.68875 2.33373 5.05793 2.33457 4.57033 2.37441C4.09538 2.41321 3.8525 2.48355 3.68306 2.56988C3.27538 2.77761 2.94392 3.10906 2.73619 3.51675C2.64986 3.68618 2.57953 3.92907 2.54072 4.40402C2.50088 4.89162 2.50004 5.52243 2.50004 6.45039V15.5504C2.50004 16.4784 2.50088 17.1092 2.54072 17.5968C2.57953 18.0717 2.64986 18.3146 2.73619 18.484C2.94392 18.8917 3.27538 19.2232 3.68306 19.4309C3.8525 19.5172 4.09538 19.5876 4.57033 19.6264C5.05793 19.6662 5.68875 19.6671 6.61671 19.6671H11.3834C12.3113 19.6671 12.9422 19.6662 13.4298 19.6264C13.9047 19.5876 14.1476 19.5172 14.317 19.4309C14.7247 19.2232 15.0562 18.8917 15.2639 18.484C15.3502 18.3146 15.4206 18.0717 15.4594 17.5968C15.4992 17.1092 15.5 16.4784 15.5 15.5504V7.75039H13.3334C11.5384 7.75039 10.0834 6.29532 10.0834 4.50039V2.33373ZM15.0233 5.58373C14.8932 5.42978 14.6852 5.21767 14.2943 4.82672L13.0071 3.53947C12.6161 3.14852 12.404 2.94061 12.25 2.81042V4.50039C12.25 5.0987 12.7351 5.58373 13.3334 5.58373H15.0233Z",
        fill: "#3A3D4D"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.76603 9.15031C9.34296 8.72724 8.65704 8.72724 8.23397 9.15031L6.0673 11.317C5.64423 11.74 5.64423 12.426 6.0673 12.849C6.49037 13.2721 7.1763 13.2721 7.59937 12.849L7.91667 12.5317V16.4163C7.91667 17.0147 8.40169 17.4997 9 17.4997C9.59831 17.4997 10.0833 17.0147 10.0833 16.4163V12.5317L10.4006 12.849C10.8237 13.2721 11.5096 13.2721 11.9327 12.849C12.3558 12.426 12.3558 11.74 11.9327 11.317L9.76603 9.15031Z",
        fill: "#3A3D4D"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5558_661",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "22",
          fill: "white"
        })
      })
    })]
  }));
};

FileUploadIcon.defaultProps = {
  width: "18",
  height: "22",
  viewBox: "0 0 18 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var GoogleDriveLogo = function GoogleDriveLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5038_1153)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1.81443 18.8547L2.87285 20.7303C3.09278 21.1252 3.40893 21.4354 3.78007 21.6611L7.56014 14.9482H0C0 15.3854 0.109966 15.8226 0.329897 16.2175L1.81443 18.8547Z",
        fill: "#0066DA"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12 7.05169L8.21993 0.338867C7.8488 0.564508 7.53265 0.874765 7.31271 1.26964L0.329897 13.6799C0.11401 14.0663 0.00028744 14.5038 0 14.9491H7.56014L12 7.05169Z",
        fill: "#00AC47"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.2806 21.6611C20.6518 21.4354 20.9679 21.1252 21.1878 20.7303L21.6277 19.9547L23.7308 16.2175C23.9507 15.8226 24.0607 15.3854 24.0607 14.9482H16.5L18.1088 18.1918L20.2806 21.6611Z",
        fill: "#EA4335"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.0301 7.05128L15.8101 0.338462C15.439 0.112821 15.0129 0 14.573 0H9.48711C9.04725 0 8.62113 0.126923 8.25 0.338462L12.0301 7.05128Z",
        fill: "#00832D"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.4698 14.9482H7.59013L3.81006 21.6611C4.18119 21.8867 4.60731 21.9995 5.04717 21.9995H19.0128C19.4527 21.9995 19.8788 21.8726 20.2499 21.6611L16.4698 14.9482Z",
        fill: "#2684FC"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.2388 7.47477L16.7473 1.26964C16.5274 0.874765 16.2113 0.564508 15.8401 0.338867L12.0601 7.05169L16.4999 14.9491H24.0463C24.0463 14.5119 23.9363 14.0748 23.7164 13.6799L20.2388 7.47477Z",
        fill: "#FFBA00"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5038_1153",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "22",
          fill: "white"
        })
      })
    })]
  }));
};

GoogleDriveLogo.defaultProps = {
  width: "24",
  height: "22",
  viewBox: "0 0 24 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var GoogleSheetsLogo = function GoogleSheetsLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M271.25 0H40.6875C18.3094 0 0 16.3841 0 36.4091V497.591C0 517.616 18.3094 534 40.6875 534H393.312C415.69 534 434 517.616 434 497.591V145.636L339.062 84.9545L271.25 0Z",
      fill: "#0F9D58"
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.5 260.932V436.909H325.5V260.932H108.5ZM203.438 412.637H135.625V382.296H203.438V412.637ZM203.438 364.091H135.625V333.75H203.438V364.091ZM203.438 315.546H135.625V285.205H203.438V315.546ZM298.375 412.637H230.563V382.296H298.375V412.637ZM298.375 364.091H230.563V333.75H298.375V364.091ZM298.375 315.546H230.563V285.205H298.375V315.546Z",
      fill: "#F1F1F1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M271.249 0V109.227C271.249 129.343 289.457 145.636 311.936 145.636H433.999L271.249 0Z",
      fill: "#87CEAC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.6875 0C18.3094 0 0 16.3841 0 36.4091V39.4432C0 19.4182 18.3094 3.03409 40.6875 3.03409H271.25V0H40.6875Z",
      fill: "white",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M393.312 530.965H40.6875C18.3094 530.965 0 514.581 0 494.556V497.59C0 517.615 18.3094 534 40.6875 534H393.312C415.69 534 434 517.615 434 497.59V494.556C434 514.581 415.69 530.965 393.312 530.965Z",
      fill: "#263238",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M311.936 145.636C289.457 145.636 271.249 129.343 271.249 109.227V112.261C271.249 132.377 289.457 148.67 311.936 148.67H433.999V145.636H311.936Z",
      fill: "#263238",
      fillOpacity: "0.1"
    })]
  }));
};

GoogleSheetsLogo.defaultProps = {
  width: "434",
  height: "534",
  viewBox: "0 0 434 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

ArrowDownIcon.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const SUPPORT_GOOGLE_DRIVE_SYNC = featureFlags.googleDriveSync;

const DataSourceSelect = _ref => {
  let {
    className = '',
    variant = '',
    disabled = false,
    options = [],
    onClick = () => null,
    onSelect
  } = _ref;
  const {
    0: menuOpen,
    1: setMenuOpen
  } = useState(false);
  const btnClassName = clsx(styles['button__icon'], variant ? styles[`button__icon--${variant}`] : '');
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, variant ? styles[`container--${variant}`] : '', className || ''),
    onMouseEnter: () => setMenuOpen(true),
    onMouseLeave: () => setMenuOpen(false),
    children: [/*#__PURE__*/_jsxs(DropdownButton, {
      disabled: disabled,
      className: clsx(styles.button, {
        [styles['button--active']]: menuOpen,
        [styles[`button--${variant}`]]: Boolean(variant)
      }),
      onClick: onClick,
      open: menuOpen,
      onOpenStateChange: setMenuOpen,
      children: [variant === 'large' ? SUPPORT_GOOGLE_DRIVE_SYNC ? /*#__PURE__*/_jsx(GoogleDriveLogo, {
        className: btnClassName
      }) : /*#__PURE__*/_jsx(GoogleSheetsLogo, {
        className: btnClassName
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(FileUploadIcon, {
        className: clsx(styles['button__icon'], variant ? styles[`button__icon--${variant}`] : '')
      }), "Add Data", /*#__PURE__*/_jsx(ArrowDownIcon, {
        className: styles.arrowIcon
      })]
    }), /*#__PURE__*/_jsx(Dropdown, {
      className: styles.dropdown,
      children: options.map((option, idx) => /*#__PURE__*/_jsx(DropdownItem, {
        className: styles.dropdownItem,
        children: /*#__PURE__*/_jsxs(DropdownAction, _objectSpread(_objectSpread({
          className: styles.dropdownAction,
          disabled: disabled
        }, !disabled && onSelect ? {
          onClick: () => onSelect(option.value)
        } : {}), {}, {
          children: [/*#__PURE__*/_jsx("img", {
            src: option.icon,
            alt: `${option.label} icon`,
            className: styles.actionIcon
          }), /*#__PURE__*/_jsxs("span", {
            className: styles.actionInfo,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.label,
              children: option.label
            }), /*#__PURE__*/_jsx("span", {
              className: styles.description,
              children: option.description
            })]
          })]
        }))
      }, `${option.label}-${idx}`))
    })]
  });
};

export default DataSourceSelect;